// extracted by mini-css-extract-plugin
export default {"profileContainer":"Profile_profileContainer__4M0qA","profileCard":"Profile_profileCard__w0YrO"};